import { createSelector } from 'reselect';
const currentFormTypeIdentifierSelector = (state, props) => {
  var _props$match;
  return props === null || props === void 0 || (_props$match = props.match) === null || _props$match === void 0 || (_props$match = _props$match.params) === null || _props$match === void 0 ? void 0 : _props$match.formTypeIdentifier;
};
const currentFormTypeListSelector = state => {
  var _state$formType;
  return state === null || state === void 0 || (_state$formType = state.formType) === null || _state$formType === void 0 ? void 0 : _state$formType.list;
};
const currentFormTypeSelector = createSelector([currentFormTypeIdentifierSelector, currentFormTypeListSelector], function (formTypeIdentifier) {
  let formTypeList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return formTypeList.find(ft => ft.identifier === formTypeIdentifier);
});
export { currentFormTypeIdentifierSelector, currentFormTypeSelector };